export default __webpack_public_path__ + "static/andysMC_logo_1-faeac9bc198c0899e8cb084854656830.png";